// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasCategoryContext, withCategory } from "@insite/client-framework/Components/CategoryContext";
import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";

type Props = WidgetProps & HasCategoryContext;

export interface CategoryInformationStyles {
    container?: InjectableCss;
    titleDescriptionWrapper?: InjectableCss;
    imageWrapper?: InjectableCss;
}

export const categoryInformationStyles: CategoryInformationStyles = {};

export const CategoryInformation = ({ category }: Props) => {
    const styles = categoryInformationStyles;

    if (!category) {
        return null;
    }
    return (
        <StyledWrapper {...styles.container}>
            <StyledWrapper {...styles.titleDescriptionWrapper}>
                {createWidgetElement("Category/CategoryName", { fields: {} })}
                {createWidgetElement("Category/CategoryDetailBanner", { fields: {} })}
            </StyledWrapper>
            <StyledWrapper {...styles.imageWrapper}>
                {createWidgetElement("Category/CategoryImage", { fields: {} })}
            </StyledWrapper>
        </StyledWrapper>
    );
};
const widgetModule: WidgetModule = {
    component: withCategory(CategoryInformation),
    definition: {
        group: "Category Details",
        allowedContexts: ["CategoryDetailsPage"],
    },
};
export default widgetModule;
